module.exports = {"version":"R1.0.006.000"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/version.json
// module id = pW2n
// module chunks = 1